import app from '../app';
import Model from '../Model';

export default class GuessGame extends Model {
  userId() {
    return Model.attribute<number>('userId').call(this);
  }
  pkgId() {
    return Model.attribute<number>('pkgId').call(this);
  }
  rid() {
    return Model.attribute<number>('rid').call(this);
  }
  roleName() {
    return Model.attribute<string>('roleName').call(this);
  }
  srvId() {
    return Model.attribute<string>('srvId').call(this);
  }
  roleLevel() {
    return Model.attribute<number>('roleLevel').call(this);
  }
  createTime() {
    return Model.attribute('createTime', Model.transformDate).call(this);
  }
  badgeOneIsLight() {
    return Model.attribute<number>('badgeOneIsLight').call(this);
  }
  badgeOneLightTime() {
    return Model.attribute('badgeOneLightTime', Model.transformDate).call(this);
  }
  badgeTwoIsLight() {
    return Model.attribute<number>('badgeTwoIsLight').call(this);
  }
  badgeTwoLightTime() {
    return Model.attribute('badgeTwoLightTime', Model.transformDate).call(this);
  }
  badgeThreeIsLight() {
    return Model.attribute<number>('badgeThreeIsLight').call(this);
  }
  badgeThreeLightTime() {
    return Model.attribute('badgeThreeLightTime', Model.transformDate).call(this);
  }
  badgeFourIsLight() {
    return Model.attribute<number>('badgeFourIsLight').call(this);
  }
  badgeFourLightTime() {
    return Model.attribute('badgeFourLightTime', Model.transformDate).call(this);
  }
  badgeFiveIsLight() {
    return Model.attribute<number>('badgeFiveIsLight').call(this);
  }
  badgeFiveLightTime() {
    return Model.attribute('badgeFiveLightTime', Model.transformDate).call(this);
  }
  badgeSixIsLight() {
    return Model.attribute<number>('badgeSixIsLight').call(this);
  }
  badgeSixLightTime() {
    return Model.attribute('badgeSixLightTime', Model.transformDate).call(this);
  }
  badgeSevenIsLight() {
    return Model.attribute<number>('badgeSevenIsLight').call(this);
  }
  badgeSevenLightTime() {
    return Model.attribute('badgeSevenLightTime', Model.transformDate).call(this);
  }
  badgeEightIsLight() {
    return Model.attribute<number>('badgeEightIsLight').call(this);
  }
  badgeEightLightTime() {
    return Model.attribute('badgeEightLightTime', Model.transformDate).call(this);
  }
  minLightTime() {
    return Model.attribute('minLightTime', Model.transformDate).call(this);
  }
  

}
